import axios from "axios";
import { getTokenHeader } from "../../../helpers/commonHelper";
import { confirmWarningConfig } from "../../../configuration/confirmConfigurations";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import OptionListDialog from "@/components/Common/OptionListDialog/OptionListDialog.vue";
export default {
  name: "Admin",
  components: { OptionListDialog },
  data: () => ({
    config: null,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "#00636C",
    mainRed: "#c55c52"
  }),
  async mounted() {
    await this.loadConfig();
  },
  methods: {
    createError(error) {
      this.snackMessage(
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
        "#c55c52"
      );
      console.error(error);
    },
    snackMessage(msg, color = "#00636C") {
      this.snackbarText = msg;
      this.snackbarColor = color;
      this.snackbar = true;
    },
    async loadConfig() {
      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal
      };
      try {
        const response = await axios.get(this.clientUrl + "config", {
          headers,
          params
        });
        this.config = response.data;
      } catch (error) {
        this.createError(error);
      }
    },
    async createConfig() {
      const postData = {
        id: this.currentPrincipal,
        _id: this.currentPrincipal
      };
      const headers = getTokenHeader();
      try {
        const res = await axios.post(`${this.clientUrl}config/`, postData, {
          headers
        });
        this.config = res.data;
      } catch (error) {
        this.createError(error);
      }
    },
    async showSubscribeOptions() {
      //merge available principal-configs with principal names
      //exclude current principal
      const principals = {};
      this.principals.map(principal => {
        principals[principal.id] = principal.name;
      });
      const configs = await this.getAllPrincipalConfigs();
      const otherConfigs = [];
      configs.map(config => {
        const name =
          config["_id"] in principals
            ? principals[config["_id"]]
            : config["_id"];
        if (this.currentPrincipal !== config["_id"]) {
          // do not include my own principal
          otherConfigs.push({ id: config["_id"], name: name });
        }
      });

      //fill dialog
      const table = {
        header: ["Mandant", "ID"],
        content: ["name", "id"],
        key: "id"
      };
      this.$refs.subscribeFromPrincipalDialog.showDialog(otherConfigs, table);
    },
    async getAllPrincipalConfigs() {
      try {
        const headers = getTokenHeader();
        const params = {
          principal_id: this.currentPrincipal
        };
        const response = await axios.get(this.clientUrl + "config/all", {
          headers,
          params
        });
        return response.data;
      } catch (error) {
        this.createError(error);
      }
    },
    async saveConfig() {
      try {
        this.config.id = this.config._id;
        const headers = getTokenHeader(),
          res = await axios.put(
            `${this.clientUrl}config/?principal_id=${this.config._id}`,
            this.config,
            { headers }
          );
        if (res.status === 200) {
          this.snackMessage("Erfolgreich gespeichert!");
        }
      } catch (err) {
        this.createError(err);
        this.snackMessage("Fehler! Nicht gespeichert!", this.mainRed);
      }
    },

    async subscribeLocations(data) {
      this.$confirm(
        `Alle Orte von "${data.name}" übernehmen (bestehende Orte bleiben bestehen)?`,
        confirmWarningConfig
      ).then(async ok => {
        if (ok) {
          try {
            const headers = getTokenHeader(),
              res = await axios.put(
                `${this.clientUrl}location/clone?from_id=${data.id}&to_id=${this.currentPrincipal}`,
                null,
                { headers }
              );

            if (res.status === 200) {
              this.snackMessage(
                res.data.updated + " Orte erfolgreich zugeordnet",
                "#000"
              );
            }
          } catch (err) {
            this.createError(err);
          }
        }
      });
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    clientUrl() {
      return env.locations_api_client_url;
    }
  }
};
